import FormattedMessage from 'I18n/components/FormattedMessage';

/* 'TEST' is a placeholder enum member with no customer-facing merch copy, so
 * it is excluded alongside unhandledEnumCase and MERCH_COPY stays exhaustive
 * over the real product groups. */
import { jsx as _jsx } from "react/jsx-runtime";
const MERCH_COPY = {
  MARKETING: {
    subheadingsByLevel: {
      FREE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingHub.subheadings.free"
      }),
      STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingHub.subheadings.starter"
      }),
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingHub.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingHub.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingHub.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingHub.lowerTierPlus.enterprise"
      })
    }
  },
  SALES: {
    subheadingsByLevel: {
      FREE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.salesHub.subheadings.free"
      }),
      STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.salesHub.subheadings.starter"
      }),
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.salesHub.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.salesHub.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.salesHub.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.salesHub.lowerTierPlus.enterprise"
      })
    }
  },
  SERVICE: {
    subheadingsByLevel: {
      FREE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.serviceHub.subheadings.free"
      }),
      STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.serviceHub.subheadings.starter"
      }),
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.serviceHub.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.serviceHub.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.serviceHub.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.serviceHub.lowerTierPlus.enterprise"
      })
    }
  },
  CONTENT: {
    subheadingsByLevel: {
      FREE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.contentHub.subheadings.free"
      }),
      STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.contentHub.subheadings.starter"
      }),
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.contentHub.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.contentHub.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.contentHub.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.contentHub.lowerTierPlus.enterprise"
      })
    }
  },
  COMMERCE: {
    subheadingsByLevel: {
      FREE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.commerceHub.subheadings.free"
      }),
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.commerceHub.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.commerceHub.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.commerceHub.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.commerceHub.lowerTierPlus.enterprise"
      })
    }
  },
  DATA: {
    subheadingsByLevel: {
      FREE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.dataHub.subheadings.free"
      }),
      STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.dataHub.subheadings.starter"
      }),
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.dataHub.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.dataHub.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.dataHub.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.dataHub.lowerTierPlus.enterprise"
      })
    }
  },
  FREE: {
    subheadingsByLevel: {
      FREE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.platform.subheadings.free"
      }),
      STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.platform.subheadings.starter"
      })
    },
    lowerTierMessagesByLevel: {}
  },
  SMART_CRM: {
    subheadingsByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.smartCrm.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.smartCrm.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.smartCrm.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.smartCrm.lowerTierPlus.enterprise"
      })
    }
  },
  PLATFORM: {
    subheadingsByLevel: {
      FREE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.platform.subheadings.free"
      }),
      STARTER: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.platform.subheadings.starter"
      }),
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.platform.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.platform.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.platform.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.platform.lowerTierPlus.enterprise"
      })
    }
  },
  HUBSPOT_CREDITS: {
    subheadingsByLevel: {},
    lowerTierMessagesByLevel: {}
  },
  HUBSPOT_FOR_MARKETERS: {
    subheadingsByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingPlus.subheadings.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingPlus.subheadings.enterprise"
      })
    },
    lowerTierMessagesByLevel: {
      PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingPlus.lowerTierPlus.professional"
      }),
      ENTERPRISE: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.marketingPlus.lowerTierPlus.enterprise"
      })
    }
  }
};
function isKnownProductGroup(pg) {
  return pg in MERCH_COPY;
}
export function getMerchCopyForProductGroup(productGroup, isStarterTierCopyRenameEnabled = false) {
  if (!isKnownProductGroup(productGroup)) {
    return {
      subheadingsByLevel: {},
      lowerTierMessagesByLevel: {}
    };
  }
  const merchCopy = MERCH_COPY[productGroup];
  if (productGroup === 'PLATFORM' && isStarterTierCopyRenameEnabled) {
    return Object.assign({}, merchCopy, {
      lowerTierMessagesByLevel: Object.assign({}, merchCopy.lowerTierMessagesByLevel, {
        PROFESSIONAL: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.platform.lowerTierPlus.professionalV2"
        })
      })
    });
  }
  return merchCopy;
}